import React, { useState, useRef } from 'react';
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  StandaloneSearchBox,
} from '@react-google-maps/api';
import { GOOGLE_API } from '../utils/constant';

const containerStyle = {
  width: '100%',
  height: '400px',
};

const predineLocation = { lat: 28.6139, lng: 77.2090 }; // Replace with actual store location

const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

function Location() {
  const [location, setLocation] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [showManual, setShowManual] = useState(false);
  const [mapCenter, setMapCenter] = useState(predineLocation);
  const searchBoxRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_API,
    libraries: ['places'],
  });

  const handleConfirmLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const coords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const distance = getDistanceInKm(
        predineLocation.lat,
        predineLocation.lng,
        coords.lat,
        coords.lng
      );
      setLocation(coords);
      setIsValid(distance <= 20);
      alert(distance <= 20 ? 'Within 20 KM – Proceed!' : 'Too far for delivery');
    });
  };

  const handleSearchChange = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places && places[0]) {
      const loc = {
        lat: places[0].geometry.location.lat(),
        lng: places[0].geometry.location.lng(),
      };
      const distance = getDistanceInKm(
        predineLocation.lat,
        predineLocation.lng,
        loc.lat,
        loc.lng
      );
      setLocation(loc);
      setMapCenter(loc);
      setIsValid(distance <= 20);
      alert(distance <= 20 ? 'Within 20 KM – Proceed!' : 'Too far for delivery');
    }
  };

  const handleMapClick = (e) => {
    const coords = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    const distance = getDistanceInKm(
      predineLocation.lat,
      predineLocation.lng,
      coords.lat,
      coords.lng
    );
    setLocation(coords);
    setIsValid(distance <= 20);
    alert(distance <= 20 ? 'Within 20 KM – Proceed!' : 'Too far for delivery');
  };

  return isLoaded ? (
    <div style={{ padding: 20 }}>
      {!showManual ? (
        <>
          <h2>Confirm Delivery Location</h2>
          <button onClick={handleConfirmLocation}>📍 Use My Current Location</button>
          <br />
          <br />
          <button onClick={() => setShowManual(true)}>🗺️ Change Location Manually</button>
        </>
      ) : (
        <>
          <h2>Select Location Manually</h2>
          <StandaloneSearchBox
            onLoad={(ref) => (searchBoxRef.current = ref)}
            onPlacesChanged={handleSearchChange}
          >
            <input
              type="text"
              placeholder="Search address"
              style={{ width: '100%', height: '40px', marginBottom: '10px', fontSize: '16px' }}
            />
          </StandaloneSearchBox>

          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={13}
            onClick={handleMapClick}
          >
            {location && <Marker position={location} />}
          </GoogleMap>

          <br />
          <button onClick={() => setShowManual(false)}>⬅️ Back</button>
        </>
      )}

      {location && (
        <div style={{ marginTop: 20 }}>
          <strong>Selected Location:</strong><br />
          Lat: {location.lat}, Lng: {location.lng}<br />
          Status: {isValid ? '✅ Within 20 KM' : '❌ Too far'}
        </div>
      )}
    </div>
  ) : (
    <p>Loading Map...</p>
  );
}

export default Location;
